import { useEffect } from 'react';
import { ProjectLockedError, refreshProjectLock, releaseProjectLock } from '../api/sophia';
import { projectLocked } from '../features/thread/threadSlice';
import { useAppDispatch } from './redux';

// Il backend fa scadere il lock dopo 120 s senza rinnovo: un heartbeat ogni 30 s lascia margine.
const HEARTBEAT_MS = 30_000;

/**
 * SPJ-1372: tiene il lock del progetto aperto finche' resta aperto, cosi' nessun altro utente puo'
 * aprirlo. Lo rilascia quando si cambia progetto, si torna alla home o si chiude la pagina; se la
 * chiusura non arriva al backend, il lock scade da solo.
 */
export function useProjectLock(threadId: string | null, enabled: boolean): void {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!threadId || !enabled) return undefined;

    let stopped = false;
    const heartbeat = async () => {
      try {
        await refreshProjectLock(threadId);
      } catch (error) {
        if (error instanceof ProjectLockedError) {
          // Lock perso (scaduto e preso da un altro utente): App riporta alla home e avvisa.
          if (!stopped) {
            dispatch(projectLocked({
              threadId,
              lockedByName: error.lockedByName,
              lockedByEmail: error.lockedByEmail,
            }));
          }
        } else {
          console.warn('Rinnovo del lock del progetto fallito', error);
        }
      }
    };
    const release = () => {
      releaseProjectLock(threadId).catch((error) => console.warn('Rilascio del lock del progetto fallito', error));
    };

    // Subito un rinnovo: l'apertura ha gia' preso il lock, ma un rilascio da un montaggio precedente
    // (es. doppio effetto in StrictMode) lo lascerebbe libero fino al primo heartbeat.
    void heartbeat();
    const interval = window.setInterval(() => void heartbeat(), HEARTBEAT_MS);
    window.addEventListener('pagehide', release);
    return () => {
      stopped = true;
      window.clearInterval(interval);
      window.removeEventListener('pagehide', release);
      release();
    };
  }, [threadId, enabled, dispatch]);
}
